const STORAGE='factory-save-slots-v1'
export default class SaveSlots {
  constructor(game){this.game=game;this.page=0;this.mode='save';this.error='';this.due=0}
  entries(){
    const raw=localStorage.getItem(STORAGE)
    if(!raw){const legacy=localStorage.getItem('factory-campaign-v1');return legacy?[{id:'legacy',name:'旧版手动存档',updatedAt:0,data:JSON.parse(legacy)}]:[]}
    const entries=JSON.parse(raw);if(!Array.isArray(entries))throw new Error('存档清单损坏，请保留浏览器数据后重试')
    return entries
  }
  write(entries){localStorage.setItem(STORAGE,JSON.stringify(entries))}
  markDirty(){this.due=Date.now()+1500}
  tick(){if(this.due&&Date.now()>=this.due)this.flush()}
  flush(){
    if(!this.due)return;this.due=0
    try{const entries=this.entries().filter(e=>e.id!=='auto');entries.unshift({id:'auto',name:'自动存档',updatedAt:Date.now(),data:this.game.captureSave()});this.write(entries)}catch(error){this.game.saveMessage='自动保存失败，请检查存储空间';this.game.saveMessageUntil=performance.now()+4000}
  }
  open(mode){this.mode=mode;this.page=0;this.error='';this.game.help='saves';this.game.settingsOpen=false}
  save(name,id){
    try{
      const entries=this.entries();name=String(name||'').trim()
      if(!name||Array.from(name).length>32)throw new Error('请输入 1–32 字的存档名称')
      if(!id&&entries.filter(e=>e.id!=='auto').length>=50)throw new Error('最多保存 50 份，请选择覆盖已有存档')
      if(id==='auto')throw new Error('自动存档由系统单独更新')
      const entry={id:id||'save-'+Date.now()+'-'+Math.random().toString(36).slice(2),name,updatedAt:Date.now(),data:this.game.captureSave()}
      this.write([entry,...entries.filter(e=>e.id!==entry.id)]);this.game.saveMessage='已保存：'+name;this.game.saveMessageUntil=performance.now()+2500;this.error='';this.naming=false;this.removeInput()
      return true
    }catch(error){this.error=error.message;return false}
  }
  load(entry){
    if(this.game.restoreSnapshot(entry.data)){this.game.help=false;this.game.saveMessage='已加载：'+entry.name;this.removeInput();return true}
    this.error='存档读取失败，当前地图已保留';return false
  }
  removeInput(){if(this.input){this.input.remove();this.input=null}}
  newName(){
    this.naming=true;this.name='';this.error='';this.removeInput()
    this.input=document.createElement('input');this.input.type='text';this.input.maxLength=32;this.input.setAttribute('aria-label','存档名称');this.input.style.cssText='position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;pointer-events:none;';document.body.appendChild(this.input)
    this.input.addEventListener('input',()=>{this.name=this.input.value});this.input.focus()
  }
  close(){this.game.help=false;this.naming=false;this.removeInput()}
  keyboard(e){
    if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='s'){e.preventDefault();if(this.naming)this.save(this.name);return}
    if(e.key==='Escape'){e.preventDefault();if(this.naming){this.naming=false;this.removeInput()}else this.close()}
    if(this.naming&&e.key==='Enter'){e.preventDefault();this.save(this.name)}
  }
  draw(){
    const g=this.game,c=g.c,w=Math.min(520,g.w-24),h=Math.min(540,g.h-24),x=(g.w-w)/2,y=(g.h-h)/2
    c.fillStyle='#24352b99';c.fillRect(0,0,g.w,g.h);g.rect(x,y,w,h,'#fcfdf8',16,'#d8e1d0');g.text(this.mode==='save'?'保存清单':'加载存档',x+20,y+28,20,'#425c37','left',700)
    g.buttons=[];g.tabRegions=[]
    g.button(x+w-54,y+12,34,30,'×',()=>this.close())
    if(this.naming){
      g.text('存档名称',x+20,y+90,14);g.rect(x+20,y+112,w-40,48,'#ffffff',8,'#ffad24');g.fitText(this.name||'点击输入名称',x+32,y+136,w-64,18,this.name?'#405a37':'#a3ad9b')
      g.buttons.push({x:x+20,y:y+112,w:w-40,h:48,fn:()=>this.input?.focus()});g.button(x+20,y+h-58,w-40,38,'新增保存',()=>this.save(this.name),true)
    }else{
      let entries=[];try{entries=this.entries()}catch(error){this.error=error.message}
      const count=Math.max(1,Math.floor((h-175)/62)),pages=Math.max(1,Math.ceil(entries.length/count));this.page=Math.min(this.page,pages-1)
      entries.slice(this.page*count,(this.page+1)*count).forEach((entry,index)=>{
        const top=y+62+index*62;g.rect(x+16,top,w-32,54,entry.id==='auto'?'#eaf0e1':'#f2f5ec',8)
        g.fitText(entry.name,x+27,top+18,w-145,14,'#46603b');g.fitText(entry.updatedAt?new Date(entry.updatedAt).toLocaleString():'旧版存档',x+27,top+39,w-145,10,'#8d9b82')
        if(this.mode==='load')g.button(x+w-100,top+9,72,34,'加载',()=>this.load(entry))
        else if(entry.id!=='auto')g.button(x+w-100,top+9,72,34,'覆盖',()=>this.save(entry.name,entry.id))
      })
      if(!entries.length)g.text('还没有存档',x+w/2,y+120,14,'#96a38b','center')
      const bottom=y+h-96;g.button(x+20,bottom,70,28,'上一页',()=>{this.page=Math.max(0,this.page-1)});g.text((this.page+1)+' / '+pages,x+w/2,bottom+14,11,'#819173','center');g.button(x+w-90,bottom,70,28,'下一页',()=>{this.page=Math.min(pages-1,this.page+1)})
      if(this.mode==='save')g.button(x+20,y+h-58,w-40,38,'＋ 新增存档',()=>this.newName(),true)
      else g.fitText('选择后才加载；自动存档也可手动恢复。',x+w/2,y+h-36,w-40,12,'#8c9b81','center')
    }
    if(this.error)g.fitText(this.error,x+20,y+h-112,w-40,12,'#b06447')
  }
}
